const FridgeList = () => import('Views/fridge/fridge-list');
const FridgeAddEdit = () => import('Views/fridge/fridge-addEdit');
const FridgeDetail = () => import('Views/fridge/fridge-detail');

export default[
  { path: '/fridge-list', component: FridgeList },
  { path: '/fridge-add', component: FridgeAddEdit },
  { path: '/fridge-edit/:id', component: FridgeAddEdit },
  { path: '/fridge-detail/:id', component: FridgeDetail },
];



// WEBPACK FOOTER //
// ./src/router/fridge.js